import { useState, type InputHTMLAttributes } from "react";
import { formatDocument, isValidCNPJ, isValidCPF, normalizeDocument } from "@cx/domain";
import { Search } from "lucide-react";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> & {
  personType: "J" | "F" | "E";
  value: string;
  onChange(v: string): void;
  onLookup?: (doc: string) => Promise<void>;
};

export function DocInput({
  personType,
  value,
  onChange,
  onLookup,
  className = "form-control",
  ...rest
}: Props) {
  const [busy, setBusy] = useState(false);
  const norm = personType === "E" ? value : normalizeDocument(value);
  const canLookup = personType === "J" && isValidCNPJ(norm) && !!onLookup;
  const placeholder =
    personType === "F"
      ? "000.000.000-00"
      : personType === "J"
        ? "00.000.000/0000-00"
        : "Documento estrangeiro";
  const marked = rest["aria-invalid"] === "true" || rest["aria-invalid"] === true;
  return (
    <div className="input-group">
      <input
        {...rest}
        className={`${className}${marked ? " is-invalid" : ""}`}
        placeholder={placeholder}
        value={
          personType === "E" ? value : norm.length === 11 || norm.length === 14 ? formatDocument(norm) : value
        }
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => personType !== "E" && (isValidCPF(norm) || isValidCNPJ(norm)) && onChange(norm)}
      />
      {personType === "J" && (
        <button
          type="button"
          className="btn btn-outline-primary"
          disabled={!canLookup || busy}
          title="Consultar na Receita"
          onClick={async () => {
            setBusy(true);
            try {
              await onLookup!(norm);
            } finally {
              setBusy(false);
            }
          }}
        >
          <Search size={16} aria-hidden="true" />{" "}
          <span className="visually-hidden">Consultar CNPJ na Receita</span>
        </button>
      )}
    </div>
  );
}
